import { createRoot } from "react-dom/client";

// third party
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// sentry monitoring
import * as Sentry from "@sentry/react";

import App from "App";
import { store } from "store";
import "assets/scss/style.scss";
import { config } from "./config";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalConfig";
import { initAnalytics, reportWebVitals } from "utilities/analytics";
import RouteTracker from "utilities/RouteTracker";
import UserIdentifier from "utilities/UserIdentifier";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const ENV = process.env.REACT_APP_ENV;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: ENV,

  integrations: [
   // Sentry.replayIntegration(),
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// GA4 — gated to prod inside utilities/analytics.js so this is a no-op in dev.
initAnalytics();
reportWebVitals();

const AppWithAuth = () => {
  return (
    <Provider store={store}>
      <BrowserRouter basename={config.basename}>
        <MsalProvider instance={msalInstance}>
          <RouteTracker />
          <UserIdentifier />
          <App />
        </MsalProvider>
      </BrowserRouter>
    </Provider>
  );
};

const container = document.getElementById("root");

// provide environment type in doc title
document.title = `b.e.dashboard (${ENV})`;

const root = createRoot(container);
root.render(<AppWithAuth />);
